module.exports = __webpack_public_path__ + "media/images/swifticons/thumbs-down-clicked-13bfd90583cfcaf1ee878f5af1ec78b0.svg";